import { render, staticRenderFns } from "./errorCode.vue?vue&type=template&id=c71d1738&scoped=true&"
import script from "./errorCode.vue?vue&type=script&lang=js&"
export * from "./errorCode.vue?vue&type=script&lang=js&"
import style0 from "./errorCode.vue?vue&type=style&index=0&id=c71d1738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d1738",
  null
  
)

export default component.exports